// src/components/settings/DistributorTable.jsx

import React, { useState, useEffect } from "react";
import DistributorRowActionMenu from "./DistributorRowActionMenu";
import "../../assets/styles/common.css";
import "./Settings.css"; // Keep this for specific settings tab styles

const DistributorTable = ({
  distributors,
  isLoading,
  error,
  openMenuId,
  actionMenuRefs,
  toggleRowActions,
  handleEditDistributor,
  handleDeleteDistributor,
  setOpenMenuId,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(distributors.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDistributors = distributors.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    } else if (totalPages === 0 && currentPage !== 1) {
      setCurrentPage(1);
    }
  }, [distributors.length, totalPages, currentPage]);

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  if (isLoading) {
    return <p className="loading-message">Loading distributors...</p>;
  }

  if (error) {
    return <p className="error-message">{error}</p>;
  }

  return (
    <div className="table-container">
      <table className="user-table">
        {/* FIX: Removed the {" "} whitespace */}
        <thead>
          <tr>
            <th>Company Name</th>
            <th>Contact Person</th>
            <th>Contact No.</th>
            <th className="actions-header">Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentDistributors.length > 0 ? (
            currentDistributors.map((distributor) => (
              <tr key={distributor.id}>
                <td>{distributor.companyName}</td>
                <td>{distributor.contactPerson}</td>
                <td>{distributor.contactNo}</td>
                <DistributorRowActionMenu
                  distributor={distributor}
                  openMenuId={openMenuId}
                  actionMenuRefs={actionMenuRefs}
                  toggleRowActions={toggleRowActions}
                  handleEditDistributor={handleEditDistributor}
                  handleDeleteDistributor={handleDeleteDistributor}
                  setOpenMenuId={setOpenMenuId}
                />
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="no-data">
                No distributors found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className="pagination-button"
          >
            Previous
          </button>
          {[...Array(totalPages).keys()].map((number) => (
            <button
              key={number + 1}
              onClick={() => paginate(number + 1)}
              className={`pagination-button ${
                currentPage === number + 1 ? "active" : ""
              }`}
            >
              {number + 1}
            </button>
          ))}
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className="pagination-button"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default DistributorTable;
